import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";

let props = {};
let inputObj = {};
let InputJSONString = "";
props["query"] = constants.serviceRoot;
props["headers"] = constants.serviceHeaders;

export const getSegments = async () => {
    // InputJSONString = JSON.stringify(input);
    inputObj["Activity"] = "F4_WF_SEGMENTS";
    inputObj["Input"] = "";
    props.input = inputObj;

const result = await GatewayGet(props, props.input);
    return result;
  };

  //Convert to multibid activity

  export const convertToMultiBid = async (input) => {
    InputJSONString = JSON.stringify(input);
   inputObj["Activity"] = "FO_COPY";
   inputObj["Input"] = InputJSONString;
   props.input = inputObj;

const result = await GatewayGet(props, props.input);
   return result;
 }

 export const FOConvertToMultiBid = async (input) => {
    InputJSONString = JSON.stringify(input);
   inputObj["Activity"] = "FO_CONVERT_MULTIBID";
   inputObj["Input"] = InputJSONString;
   props.input = inputObj;

const result = await GatewayGet(props, props.input);
   return result;
 }

 //Send back document

 export const FOSentBack = async (input) => {
    InputJSONString = JSON.stringify(input);
   inputObj["Activity"] = "FO_INVOICE_AUTHORIZE";
   inputObj["Input"] = InputJSONString;
   props.input = inputObj;

const result = await GatewayGet(props, props.input);
   return result;
 }

 export const FOReject = async (input) => {
   InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "FO_REJECT";
  inputObj["Input"] = InputJSONString;
  props.input = inputObj;

const result = await GatewayGet(props, props.input);
  return result;
}

export const FOUpdateContactEmail = async (input) => {
   InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "FO_UPDATE_CONTACT_EMAIL";
  inputObj["Input"] = InputJSONString;
  props.input = inputObj;

const result = await GatewayGet(props, props.input);
  return result;
}

export const FOAuthorize = async (input) => {
   InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "FO_AUTHORIZE";
  inputObj["Input"] = InputJSONString;
  props.input = inputObj;

const result = await GatewayGet(props, props.input);
  return result;
}

export const FOSubmit = async (input) => {
   InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "FO_SUBMIT";
  inputObj["Input"] = InputJSONString;
  props.input = inputObj;

const result = await GatewayGet(props, props.input);
  return result;
}

export const getUserDetails = async () => {
  // InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "GET_USER_DETAILS";
  inputObj["Input"] = "";
  props.input = inputObj;

const result = await GatewayGet(props, props.input);
  return result;
};

export const getWorkListData = async (input) => {
  InputJSONString = JSON.stringify(input);
 inputObj["Activity"] = "Q_AUTH_WLIST";
 inputObj["Input"] = InputJSONString;
 props.input = inputObj;

const result = await GatewayGet(props, props.input);
 return result;
}







